var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-loading-container",attrs:{"data-testid":"full-screen-loader"}},[_c('div',[_c('img',{attrs:{"src":require("./kong-loader.gif")}}),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: `${_vm.progression}%` }),attrs:{"role":"progressbar"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }